export default [
	{
		key: 'urbanDevelopment',
		name:
			'World Bank: Urban development and enhanced climate resilience project',
		opacity: 0.7,
		options: {
			url: 'http://37.205.9.25:8080/geoserver/wbcrp/wms',
			params: {
				layers: 'wbcrp:drr_wbcrp_padmap',
			},
		},
		type: 'wms',
	},
	{
		key: 'evolution',
		name: 'DLR: World Settlement Footprint - Evolution (1985-2015)',
		opacity: 0.7,
		options: {
			url: 'http://37.205.9.25:8080/geoserver/wbcrp/wms',
			params: {
				layers: 'wbcrp:drr_wbcrp_wsf',
			},
		},
		type: 'wms',
	},
	{
		key: 'occurrence',
		name: 'Water Occurrence (1984-2019)',
		opacity: 0.7,
		options: {
			url:
				'https://storage.googleapis.com/global-surface-water/tiles2019/occurrence/{z}/{x}/{y}.png',
			maxNativeZoom: 13,
		},
		type: 'wmts',
	},
	{
		key: 'change',
		name: 'Water Occurence Change Intensity (1984-1999 to 2000-2019)',
		opacity: 0.7,
		options: {
			url:
				'https://storage.googleapis.com/global-surface-water/tiles2019/change/{z}/{x}/{y}.png',
			maxNativeZoom: 13,
		},
		type: 'wmts',
	},
	{
		key: 'seasonality',
		name: 'Water Seasonality (2019)',
		opacity: 0.7,
		options: {
			url:
				'https://storage.googleapis.com/global-surface-water/tiles2019/seasonality/{z}/{x}/{y}.png',
			maxNativeZoom: 13,
		},
		type: 'wmts',
	},
	{
		key: 'recurrence',
		name: 'Annual Water Recurrence (1984-2019)',
		opacity: 0.7,
		options: {
			url:
				'https://storage.googleapis.com/global-surface-water/tiles2019/recurrence/{z}/{x}/{y}.png',
			maxNativeZoom: 13,
		},
		type: 'wmts',
	},
	{
		key: 'transitions',
		name: 'Water Transitions (First Year to Last Year)',
		opacity: 0.7,
		options: {
			url:
				'https://storage.googleapis.com/global-surface-water/tiles2019/transitions/{z}/{x}/{y}.png',
			maxNativeZoom: 13,
		},
		type: 'wmts',
	},
];

// export default [{
// 	key: "susceptibility",
// 	name: "Susceptibility",
// 	opacity: 0.7,
// 	options: {
// 		url: "http://185.8.165.36:8080/geoserver/eo4sd/wms?",
// 		params: {
// 			layers: "eo4sddrr_06wbmya02_ls-susceptibility"
// 		}
// 	},
// 	type: "wms"
// },{
// 	key: "inventory",
// 	name: "Inventory",
// 	options: {
// 		url: "http://185.8.165.36:8080/geoserver/eo4sd/wms?",
// 		params: {
// 			layers: "eo4sddrr_06wbmya01_ls-inventory"
// 		}
// 	},
// 	type: "wms"
// },{
// 	key: "stationing",
// 	name: "Stationing",
// 	options: {
// 		url: "http://185.8.165.36:8080/geoserver/eo4sd/wms?",
// 		params: {
// 			layers: "eo4sddrr_06wbmya00_chinroad_stationing"
// 		}
// 	},
// 	type: "wms"
// }];
